import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import ProductAdderBody from './ProductAdderBody';
import ProductAdderHeader from './ProductAdderHeader';
import { device } from '@src/common/breakpoints';
import { useAppSelector, useWidgetParam } from '@src/core/hooks';
import { productSelector, productAdderStepState } from '@src/stores/product';
import { useWidgetId } from '@src/core/IdProvider';
import useFeatureFlag from '@src/hooks/useFeatureFlag';
import { shouldHideSteps as shouldHideStepsRule } from '@src/domains/products/core/visibility';

const ProductAdderRoot = () => {
  const productId = useWidgetParam('product-id')!;
  const product = useAppSelector(productSelector(productId));

  const { isFeatureFlagEnabled } = useFeatureFlag();

  const widgetId = useWidgetId();
  const { currentStep } = useAppSelector(productAdderStepState(widgetId));

  const hideSteps = useMemo(
    () => shouldHideStepsRule(currentStep, isFeatureFlagEnabled('PR-3221-seat-map')),
    [currentStep, isFeatureFlagEnabled],
  );

  return (
    <ProductAdderArea data-cy='productAdderModal' $shouldHideSteps={hideSteps}>
      <ProductAdderHeader title={product?.name ?? ''} hideSteps={hideSteps} />
      <ProductAdderBody />
    </ProductAdderArea>
  );
};

const ProductAdderArea = styled.div<{ $shouldHideSteps: boolean }>`
  background-color: white;
  width: 100%;
  pointer-events: all;
  overflow: hidden;

  ${device.smallTablet} {
    border-radius: 8px;
  }

  ${({ $shouldHideSteps }) =>
    $shouldHideSteps &&
    css`
      height: 100vh;
    `}
`;

export default ProductAdderRoot;
